module.exports = __webpack_public_path__ + "img/apply_banner.a5108343.png";